// Constants for tracking URLs
export const CANADA_POST_URLS = {
  fr: 'https://www.canadapost-postescanada.ca/track-reperage/fr#/search?searchFor=',
  en: 'https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor='
};

export const getCurrentLanguage = (): string => {
  return localStorage.getItem('i18nextLng') || 'en';
};

export const handleTrackingClick = (trackingNumber: string | undefined, e: React.MouseEvent) => {
  e.stopPropagation();
  
  if (!trackingNumber) return;

  const currentLanguage = getCurrentLanguage();
  window.open(CANADA_POST_URLS[currentLanguage as keyof typeof CANADA_POST_URLS] + trackingNumber, '_blank');
}; 